/**
 * TanStack Query Client Configuration
 * 
 * Centralized query client with default options optimized for this application.
 * Used for caching API responses for data that changes infrequently.
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Default stale time: 5 minutes
      // Data is considered fresh for this duration and won't trigger a refetch
      staleTime: 5 * 60 * 1000,
      
      // Garbage collection time: 30 minutes
      // Inactive queries are removed from cache after this duration
      gcTime: 30 * 60 * 1000,
      
      // Retry failed requests up to 2 times
      retry: 2,
      
      // Don't refetch on window focus by default
      // (individual queries can override this)
      refetchOnWindowFocus: false,
      
      // Don't refetch on reconnect by default
      refetchOnReconnect: false,
    },
  },
});
